const NavbarActionTypes = {
  SET_IS_COLLAPSED: "SET_IS_COLLAPSED",
  UPDATE_SUBMENU_STATE: "UPDATE_SUBMENU_STATE",
}

export default NavbarActionTypes
